var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralHumidity = function SvgDAhuGeneralHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "548,460 560,448 560,376 558,376 558,360 550,360 550,376 548,376",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 360,
    width: 1,
    height: 91,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553,
    y: 360,
    width: 2,
    height: 93,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "550,458 551,458 551,360 550,360",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "560,448 548,460 586,460 586,448",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 457,
    width: 36,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553,
    y: 453,
    width: 33,
    height: 2,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557,450 557,451 586,451 586,450",
    fill: "#787878"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 300,
    width: 32,
    height: 60,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,301v58h-30v-58H569 M570,300h-32v60h32V300L570,300z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 521.3,
    y: 329.5,
    transform: "matrix(0.469 -0.8832 0.8832 0.469 2.7019 664.5419)",
    width: 65.3,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "549.5,307 546.3,307 546.3,303.8 544.8,303.8 544.8,307 541.5,307 541.5,308.5 544.8,308.5 544.8,311.8 546.3,311.8 546.3,308.5 549.5,308.5",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 300,
    width: 32,
    height: 60,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,301v58h-30v-58H533 M534,300h-32v60h32V300L534,300z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 354.5,
    width: 32,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.5,
    y: 300,
    width: 1,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.5,
    y: 300,
    width: 1,
    height: 60
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 505.8,
    y: 305,
    width: 1,
    height: 55
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "509,312.1 505.9,308.5 508.8,305 509.5,305.6 507.2,308.5 509.7,311.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "509,320.5 505.9,316.9 508.8,313.3 509.5,313.9 507.2,316.9 509.7,319.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.8,328.8 505.9,325.2 509,321.6 509.7,322.3 507.2,325.2 509.5,328.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 514.3,
    y: 305,
    width: 1,
    height: 55
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.3,312.1 511.5,311.5 514.1,308.5 511.6,305.6 512.4,305 515.4,308.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.3,320.5 511.5,319.8 514.1,316.9 511.6,313.9 512.4,313.3 515.4,316.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.4,328.8 511.6,328.1 514.1,325.2 511.5,322.3 512.3,321.6 515.4,325.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 554,
    y1: 408,
    x2: 554,
    y2: 380,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 393,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "546.9,407.5 554,395 561.2,407.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,396l6.3,11h-12.5L554,396 M554,394l-8,14h16L554,394L554,394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "546.9,380.5 561.2,380.5 554,393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.8,381h12.5l-6.3,11L547.8,381 M546,380l8,14l8-14L546,380L546,380z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 394,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,384c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S569.5,384,575,384 M575,383c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S581.1,383,575,383L575,383z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.9,391.1l1.6,4.4l1.6-4.4h1.3v5.7h-1V395l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7H573.9L573.9,391.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 558.5,
    y: 421,
    width: 5.5,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 394,
    r: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,390c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S551.8,390,554,390 M554,389c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 S556.8,389,554,389L554,389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 408.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,409v2h-14v-2H561 M562,408h-16v4h16V408L562,408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.5,
    y: 432.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,433v2h-14v-2H561 M562,432h-16v4h16V432L562,432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 549.5,
    y: 411.5,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,412v20h-8v-20H558 M559,411h-10v22h10V411L559,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.2,432.2c-1.8-2.7-2.9-6.5-2.9-10.1s1.1-7.5,2.9-10.2l0.8,0.6c-1.7,2.5-2.8,6.2-2.8,9.6s1,7,2.8,9.6L558.2,432.2 L558.2,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.9,432.2l-0.8-0.6c1.7-2.5,2.8-6.1,2.8-9.6s-1-7.1-2.8-9.6l0.8-0.6c1.8,2.7,2.9,6.5,2.9,10.2 S551.7,429.5,549.9,432.2L549.9,432.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 411,
    width: 22,
    height: 22,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,412v20h-20v-20H585 M586,411h-22v22h22V411L586,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M576.5,419h1.1l-2,5.7h-1l-2-5.7h1.1l1.4,4.4L576.5,419L576.5,419z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 405,
    transform: "matrix(1 -3.141572e-03 3.141572e-03 1 -1.2788 1.8085)",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "581.4,438.4 580,433 578.5,438.4 579.5,438.4 579.5,443 580.5,443 580.5,438.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570,433 568.6,438.4 569.5,438.4 569.5,443 570.5,443 570.5,438.4 571.5,438.4"
  }))))));
};
export default SvgDAhuGeneralHumidity;